import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { PriceQuoteAction } from 'routes/essential-workspace/components/quote-panel/quote/quote-actions/price';
import { QuoteStatus } from 'routes/essential-workspace/components/quote-status';

export function QuoteReadySummary({ className, formId }: { className?: string; formId: string }) {
  return (
    <div className={classNames('flex-x text-start gap-3 justify-content-between w-100', className)}>
      <div className="flex-x gap-2">
        <QuoteStatus variant="icon" formId={formId} />
        <div className="text-truncate overflow-hidden fw-medium">
          <FormattedMessage id="sidePanel.quoteStatus.readyToPrice" />
        </div>
      </div>

      <PriceQuoteAction size="lg" purpose="primary" labelTranslationKey="sidePanel.actions.price" />
    </div>
  );
}
